import { createFileRoute } from "@tanstack/react-router";
import BookingDetail from "../components/BookingDetail";
import AuthGuard from "../components/AuthGuard";

export const Route = createFileRoute("/bookings/$bookingGuid/")({
  component: () => (
    <AuthGuard>
      <BookingDetail />
    </AuthGuard>
  ),
});
